import FieldDimensionId from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import { LibraryShapeId } from '@core/constants/Shape';
import {
    IDimensionUnit,
    IFormFieldDimension,
    IFormFieldDimensionDefaultValueKey,
    IFormFieldMaterial,
    IFormFieldShapeQuantities,
    IFormInputType,
} from '../../../interfaces/Form';
import {
    allEngineeredWoods,
    allGlasses,
    allMarbleAndStones,
    allMelamine,
    allMetals,
    allSolidWoods,
    allVeneerWoods,
    getMaterialsWithExceptions,
} from './materialGroups';

export const fieldsLibraryMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions([
            ...allEngineeredWoods,
            ...allVeneerWoods,
            ...allSolidWoods,
            ...allMetals,
            ...allMarbleAndStones,
            ...allGlasses,
            ...allMelamine,
        ],
        [
            MaterialId.BlackLocust,
            MaterialId.Iroko,
            MaterialId.Douglas,
            MaterialId.DouglasEngineered,
            MaterialId.DouglasVeneer,
            MaterialId.Larch,
            MaterialId.LarchEngineered,
            MaterialId.LarchVeneer,
            MaterialId.Padouk,
            MaterialId.PadoukEngineered,
            MaterialId.PadoukVeneer,
            MaterialId.Ipe,
            MaterialId.IpeEngineered,
            MaterialId.IpeVeneer,
            MaterialId.DriftWood,
            MaterialId.WroughtIron,
            MaterialId.Garapa,
            MaterialId.Brass,
            MaterialId.Zinc,
            MaterialId.SheetMetal,
            MaterialId.StainlessSteel,
            MaterialId.ThermoLaqueredBlack,
            MaterialId.ThermoLaqueredWhite,
            MaterialId.Rust,
        ]),
        required: true,
    },
};

export const fieldsLibraryAddOns: IFormFieldShapeQuantities = {
    [LibraryShapeId.Niche]: {
        value : undefined,
        min   : 0,
        max   : 25,
    },
    [LibraryShapeId.Door]: {
        value : undefined,
        min   : 0,
        max   : 5,
    },
    [LibraryShapeId.Drawer]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [LibraryShapeId.Shelf]: {
        value : undefined,
        min   : 0,
        max   : 25,
    },
};

export const fieldsLibraryLargeDimension: IFormFieldDimension = {
    [FieldDimensionId.Height]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 100,
        range         : { min: 500, max: 3000 },
        required      : true,
        defaultValue  : 2000,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardHeight, 2000],
        ],
    },
    [FieldDimensionId.Width]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 100,
        range         : { min: 500, max: 6000 },
        required      : true,
        defaultValue  : 2000,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardWidth, 2000],
        ],
    },
    [FieldDimensionId.Depth]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 100,
        range         : { min: 200, max: 800 },
        required      : true,
        defaultValue  : 300,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardWidth, 300],
        ],
    },
    [FieldDimensionId.Thickness]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 10,
        range         : { min: 10, max: 50 },
        required      : true,
        defaultValue  : 20,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
        ],
    },
};

export const fieldsLibraryRegulardDimension: IFormFieldDimension = {
    [FieldDimensionId.Height]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 100,
        range         : { min: 500, max: 3000 },
        required      : true,
        defaultValue  : 1000,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardHeight, 1000],
        ],
    },
    [FieldDimensionId.Width]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 100,
        range         : { min: 500, max: 4000 },
        required      : true,
        defaultValue  : 1000,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardWidth, 1000],
        ],
    },
    [FieldDimensionId.Depth]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 100,
        range         : { min: 200, max: 800 },
        required      : true,
        defaultValue  : 300,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardWidth, 300],
        ],
    },
    [FieldDimensionId.Thickness]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 10,
        range         : { min: 10, max: 50 },
        required      : true,
        defaultValue  : 20,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
        ],
    },
};

